/* eslint-disable no-return-assign */
import React, { useContext, useRef, useEffect } from 'react'; //eslint-disable-line
import { observer } from 'mobx-react-lite';
import { gsap, Linear } from 'gsap';
import locationStoreContext from '../stores/locationStore';
import viewStoreContext from '../stores/viewStore';
import goTrackerConfig from 'goTrackerConfig';
import { DEFAULT_MOBILE_SCREEN_SIZE } from '../utils/constants';

const MessageBanner = observer(()=> {
  const locationStore = useContext(locationStoreContext);
  const viewStore = useContext(viewStoreContext);
  const messagesRef = useRef([]);
  const masterTimeLine = gsap.timeline({ repeat: -1, paused: true });

  const hideElement = element => {
    gsap.set(element, {x: '100vw', xPercent: 0, visibility: 'hidden'});
  };

  const doAnimation = (message) => {
    /**Think of scrollingMessageRate as in pixels moved per second, increasing the rate will speed up the message.*/
    const duration = ((message.offsetWidth + viewStore.viewPort.width ) / viewStore.viewPort.width) * (
      DEFAULT_MOBILE_SCREEN_SIZE / (goTrackerConfig.scrollingMessageRate || 40)
    );
    const timeline = gsap.to(message, duration, {
      x: '-=100vw',
      xPercent: -100,
      delay: 0,
      ease: Linear.easeNone,
      visibility: 'visible',
      onComplete: hideElement(message)
    },
    '>'
    );

    return timeline;
  };

  // const adjustTimeScale = () => {
  //   const timeScale = (DEFAULT_MOBILE_SCREEN_SIZE + viewStore.viewPort.width / viewStore.viewPort.width) / 1000;

  //   masterTimeLine.timeScale(timeScale);
  // };

  const resizeCheck = () => {
    viewStore.updateViewPort();

    // Save current progress
    const progress = masterTimeLine.progress();

    // Stop animation
    masterTimeLine.kill();

    // Adjust speed of animation when screen size changes
    // adjustTimeScale();

    // Restart animation at the saved progress
    masterTimeLine.progress(progress);
  };

  const saveAnimation = () => {
    // Make a copy current animation timeline progress
    viewStore.currentTimeLine = masterTimeLine.progress();

    // Kill old timeline
    masterTimeLine.kill();
  };

  const addAnimation = () => {
    console.log('addAnimations');

    messagesRef.current.forEach(m => {
      if (!m) return;

      masterTimeLine.add(doAnimation(m));
    });
  };

  useEffect(() => {
    addAnimation();

    window.addEventListener('resize', resizeCheck);

    //Get stored timeline
    if (viewStore.currentTimeLine) {
      masterTimeLine.progress(viewStore.currentTimeLine);
    }

    if (!masterTimeLine.isActive()) {
      masterTimeLine.play();
    }

    return () => {
      saveAnimation();
      window.removeEventListener('resize', resizeCheck);
    };
  });

  return (
    <aside className="message-banner-container">
      <span className="scrolling-messages">
        {locationStore.scrollingMessages && locationStore.scrollingMessages.map((m, i) => {
          if(m === undefined || m.isTakeover)  {
            return (
              <p></p>
            );
          }
          let messages = {};
          if(m.text) {
            messages = m.text.find(t => t.language === viewStore.languageName);
          }
          const busMsg = m[`${viewStore.languageName.toLowerCase()}`] ?? '';
          if(busMsg) {
            messages.text = busMsg;
          }

          const busDetailMsg = m.message !== undefined ? m.message : m.frenchMessage ?? '';
          if(busDetailMsg) {
            messages.text = busDetailMsg;
          }
          if (messages === undefined || messages.text === undefined) return '';

          const scrollingMessages = `${messages.text} `;

          return (
            <p key={i} ref={e => messagesRef.current[i] = e} className="message">{scrollingMessages}</p>
          );
        })}
      </span>
    </aside>
  );
});

export default MessageBanner;
